export default {
  data: () => ({
    valid: {}
  }),

  computed: {
    isValid() {
      return Object.values(this.valid).every(i => Boolean(i));
    }
  },

  methods: {
    setValid(index, value) {
      this.$set(this.valid, index, value);
    }
  }
};
